import type { UserInfo } from '@module/apis/client-side/member/type';
import { createContext, type Dispatch } from 'react';

export type F_Select = { title: string; img: string; url: string };

export type Context = {
  navigateHandler: (path: F_Select) => void;
  addItemHandler: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, el: F_Select) => void;
  selectList: F_Select[];
  setSelectList: Dispatch<F_Select[]>;
  isAdult: boolean;
  userInfo: UserInfo | undefined;
  initMyListHandler: (type: 'my' | 'chnnel' | 'customer') => F_Select[];
};
const MenuContext = createContext<Context>({
  navigateHandler: () => {},
  addItemHandler: () => {},
  selectList: [],
  setSelectList() {},
  isAdult: false,
  userInfo: undefined,
  initMyListHandler: () => [],
});

export default MenuContext;
